<template>
  <div class="videos">
    <v-container fluid>
      <v-row>
        <v-col cols="12" class="py-0 px-0">
          <div class="wrap">
            <div>
              <v-img src="@/assets/img/Video-portada.jpg" class="intro-img"></v-img>
            </div>

            <div class="overlay">
              <div class="text-overlay">
                <span class="titles bold">{{videoSingleton.title}}</span>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>

    <v-container class="py-0">
      <!-- desk -->
      <v-row align="center" class="d-none d-md-flex">
        <v-col cols="12" md="6">
          <video width="100%" controls loop muted>
            <source
              :src="'https://www.mlcpcms.actstudio.xyz/storage/uploads'+videoSort.video.path"
              type="video/mp4"
            />
          </video>
        </v-col>
        <v-col cols="12" md="6">
          <div class="max-width-1 mx-auto">
            <div>
              <span class="subtitles bold">{{toUpperCase(videoSort.title)}}</span>
            </div>
            <div class="mt-4">
              <p>{{videoSort.description}}</p>
            </div>
          </div>
        </v-col>
      </v-row>

      <v-row class="d-none d-md-flex">
        <v-col cols="12" class="position-relative">
          <div class="arrow-left videos-section" @click="previewSlide()">
            <!-- <v-icon class="icon-arrow-left-videos">mdi-chevron-left</v-icon> -->
            <v-img src="@/assets/png/flecha.png" class="icon-arrow-left"></v-img>
          </div>

          <div class="arrow-right videos-section" @click="nextSlide()">
            <!-- <v-icon class="icon-arrow-right-videos">mdi-chevron-right</v-icon> -->
            <v-img src="@/assets/png/flecha.png" class="icon-arrow-right"></v-img>
          </div>

          <v-sheet width="100%">
            <v-slide-group v-model="videosSlide" :show-arrows="false">
              <v-slide-item v-for="(otherVideos, ov) in videos" :key="ov">
                <v-card class="mr-3 card-video" tile elevation="0">
                  <div>
                    <div>
                      <video width="100%" controls loop muted class="video-custom">
                        <source
                          :src="'https://www.mlcpcms.actstudio.xyz/storage/uploads'+otherVideos.video.path"
                          type="video/mp4"
                        />
                      </video>
                    </div>

                    <div>
                      <div>
                        <span class="subtitles bold">{{toUpperCase(otherVideos.title)}}</span>
                      </div>
                      <div class="mt-4">
                        <p class="max-width-2">{{otherVideos.description}}</p>
                      </div>
                    </div>
                  </div>
                </v-card>
              </v-slide-item>
            </v-slide-group>
          </v-sheet>
        </v-col>
      </v-row>
      <!-- desk -->

      <!-- mobile -->
      <v-row align="center" class="d-md-none px-2">
        <template v-for="(mainVideo, mv) in videosMobile">
          <v-col cols="12" md="6" :key="mv">
            <video width="100%" controls loop muted>
              <source
                :src="'https://www.mlcpcms.actstudio.xyz/storage/uploads'+mainVideo.video.path"
                type="video/mp4"
              />
            </video>
          </v-col>
          <v-col cols="12" md="6" :key="mv+'2'">
            <div class="max-width-1">
              <div>
                <span class="subtitles bold">{{toUpperCase(mainVideo.title)}}</span>
              </div>
              <div>
                <p>{{mainVideo.description}}</p>
              </div>
            </div>
          </v-col>
        </template>
      </v-row>
      <!-- mobile -->
    </v-container>
  </div>
</template>

<script>
export default {
  data: () => ({
    videos: [],
    videosMobile: [],
    videoSort: {},
    videosSlide: 0,
    videoSingleton: {}
  }),
  created: function () {
    var aux = this;

    //get singleton videos 
    fetch(
      "https://www.mlcpcms.actstudio.xyz/api/singletons/get/videos?token=16db21f0656450d15b7ee93d559638",
      {
        method: "post",
        headers: {
          "Content-Type": "application/json",
        }
      }
    )
    .then(data => data.json())
    .then(data => (aux.videoSingleton = data));

    //get collection videos
    fetch(
      "https://www.mlcpcms.actstudio.xyz/api/collections/get/videos?token=16db21f0656450d15b7ee93d559638",
      {
        method: "post",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          sort: { _created: -1 },
        }),
      }
    )
      .then((res) => res.json())
      .then(function (res) {
        //global variable of the entries
        var entries = res.entries;

        //set the recently video
        aux.videoSort = entries[0];

        //set all videos for desk slide
        for (let index = 1; index < entries.length; index++) {
          const element = entries[index];
          aux.videos.push(element);
        }

        //set all videos for mobile slide
        for (let index = 0; index < entries.length; index++) {
          const element = entries[index];
          aux.videosMobile.push(element);
        }
      })
      .catch((error) => console.log(error.message));
  },
  mounted: function () {
    this.$emit("update", 1);
  },
  methods: {
    toUpperCase: function (title) {
      if (title != undefined) {
        var uppercase = title.charAt(0).toUpperCase() + title.slice(1);
      }

      return uppercase;
    },
    nextSlide: function () {
      this.videosSlide++;

      if (this.videosSlide >= this.videos.length) {
        this.videosSlide = 0;
      }
    },
    previewSlide: function () {
      this.videosSlide--;

      if (this.videosSlide < 0) {
        this.videosSlide = this.videos.length - 1;
      }
    },
  },
};
</script>